export const instituteTypes = [
  { value: 1, name: 'Primary' },
  { value: 2, name: 'Secondary' },
  { value: 3, name: 'Higher Secondary' },
]

export const ownerTypes = [
  { value: 1, name: 'Founder' },
  { value: 2, name: 'Trust' },
  { value: 3, name: 'Society' },
  { value: 4, name: 'Management Board' },
]

export const currencyCodes = [
  { value: 'INR', name: 'INR' },
]

export const currencySymbols = [
  { value: '₹', name: '₹' },
]

export const themeFonts = [
  { value: 'Source Sans Pro', name: 'Source Sans Pro' },
]

export const themeColors = [
  { value: '#1b55e3', name: 'Blue' },
  { value: '#da0505', name: 'Red' },
  { value: '#652eff', name: 'Purple' },
]

export const paymentFrequencies = [
  { value: 0, name: 'Monthly' },
  { value: 1, name: 'Quarterly' },
  { value: 2, name: 'Yearly' },
]

export const countryCodes = [
  { value: '91', name: '+91' },
  { value: '0', name: '+0' },
]
